module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_okunai@2x-6cc09628b534cd6c430fdeab971e92eb.webp";